import { classNames } from "shared/lib/classNames/classNames";
import { useSelector } from "react-redux";
import { getPlotStepData } from "widgets/PlotSteps";
import { useEffect } from "react";
import { useCountUp } from "react-countup";
import { getPlotOptions } from "features/User/modal/selectors/getUserData/getUserData";
import { Buttons } from "../Buttons";
import cls from "./FinalSum.module.scss";

interface FinalSumProps {
    className?: string;
}
export const FinalSum = (props: FinalSumProps) => {
    const { className } = props;
    const stepData = useSelector(getPlotStepData);
    const walletSum = stepData?.action?.finalSum?.value;
    const count = useCountUp({
        ref: "counter",
        start: 0,
        end: walletSum,
        separator: " ",
        suffix: " &#8381;",
    });
    const { pauseResume, update } = count;

    useEffect(() => {
        pauseResume();
        if (walletSum) {
            pauseResume();
            update(walletSum);
        }
    }, [stepData]);

    return (
        <div className={classNames(cls.FinalSum, {}, [className])}>
            <div className={cls.speaker}>
                <img
                    className={cls.speakerImg}
                    src={stepData?.action?.finalSum?.speakerImg}
                    alt="Персонаж"
                />
            </div>
            <div className={cls.box}>
                <div className={cls.description}>
                    <img
                        className={cls.icon}
                        src={stepData?.action?.finalSum?.icon}
                        alt="Иконка первого уровня"
                    />
                    <div className={cls.descriptionText}>
                        {stepData?.action?.finalSum?.descriptionText}
                    </div>
                </div>
                <div className={cls.text}>Баланс кошелька</div>
                <div className={cls.sum}>
                    <div id="counter" />
                    {/* {finalSum} */}
                    {/* {' '} */}
                    {/* &#8381; */}
                </div>
            </div>
            <div className={cls.forward}>
                <Buttons />
            </div>
        </div>
    );
};
